/**
 * アプリ全体の識別・メタ情報（ハードコード禁止ルールに従い定数化）。
 *
 * 参考: `.claude/rules/no-hardcode.md`
 */

/**
 * アプリバージョン。
 *
 * 原則として `package.json` の version と同期する。
 * ビルド時に自動同期する仕組みは Phase 2（Capacitor 導入時）で検討する。
 */
export const APP_VERSION = '1.0.3'

/** アプリ表示名（設定画面 Info タブなどで利用）。 */
export const APP_DISPLAY_NAME = 'ラッキーどうぶつナワバリ'

/** 著作権表示文言。 */
export const APP_COPYRIGHT = '© YamanekoGames'

/** ストア審査・アプリ内表示で使う公開サポートメール。 */
export const APP_SUPPORT_EMAIL = 'contact@yamaneko.works'

/** 公開プライバシーポリシー URL。 */
export const APP_PRIVACY_URL = 'https://luckyanimal-nawabari.web.app/privacy.html'

/** 公開サポート URL。 */
export const APP_SUPPORT_URL = 'https://luckyanimal-nawabari.web.app/support.html'

/** Google Play の Data deletion URL / 審査メモで使うアカウント削除 URL。 */
export const APP_ACCOUNT_DELETION_URL =
  'https://luckyanimal-nawabari.web.app/account-deletion.html'
